/**
 * FileAlt Icon Component
 * 
 * SVG icon for log-related alerts
 */

import React from 'react';

const FileAltIcon = ({ size = 16, color = 'currentColor', className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={`file-alt-icon ${className}`}
      aria-hidden="true"
      {...props}
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="8" y1="13" x2="16" y2="13"></line>
      <line x1="8" y1="17" x2="16" y2="17"></line>
      <line x1="10" y1="9" x2="14" y2="9"></line>
    </svg>
  );
};

export default FileAltIcon;
